export default "__VITE_ASSET__CIOgqKW4__"